module.exports = __webpack_public_path__ + "static/img/医院AI审核_产品截图2@2x.bb77be21.png";